import { useOrder } from '@core/composables/order/useOrder'

export const useNavigationButtons = () => {
  const { activeStep } = useOrder()

  let navigate = (isNextButton) => {
    isNextButton ? activeStep.value++ : activeStep.value--
  }

  return {
    navigate,
  }
}
